<template>
  <div class="px-4 pb-20 pt-[4.25rem]">
    <!-- パスワード再設定フォーム -->
    <div class="co-container-xs mx-auto !max-w-[600px] bg-white shadow-[0_0_4px_rgba(51,51,51,0.2)]">
      <div class="co-display-8 border-b border-dotted border-b-[#ccc] px-5 py-2">
        パスワードの再設定
      </div>
      <div class="px-5 py-8">
        <p class="mb-4 ml-4 text-center">
          パスワード再設定用のURLをメールにてご案内します。
          LINEヤフーテックアカデミーに登録したメールアドレスを入力してください。
        </p>
        <form @submit.prevent>
          <!-- メールアドレス -->
          <div class="mx-1">
            <input
              v-model="email"
              placeholder="メールアドレス"
              type="email"
              required
              class="input w-full border-2 border-co-gray-300"
            >
            <span
              v-if="errors.email && errors.email.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.email.join(', ') }}
            </span>
          </div>
          <!-- ボタン -->
          <div class="pt-5 text-right">
            <button
              class="co-btn-submit co-btn-small ya-te-btn-red !w-[8.875rem]"
              @click="onSubmit(true)"
            >
              メールを送信
            </button>
            <span
              v-if="applicationErrors.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ applicationErrors.join(", ") }}
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaLYTATags } from '~/utility/constants/metaTags'
import { postYahooPasswordForgot } from '~/utility/fetchAPI'
import validatePasswordForgotForm from '~/utility/validation/validatePasswordForgotForm'

const options = {
  async setup() {
    definePageMeta({
      layout: 'yate-simple'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'yahoo',
    })
    return {
      title: 'パスワードの再設定 | テックアカデミー',
      meta: [
        ...metaLYTATags(
          {
            keywords:
              'プログラミング, ブートキャンプ, エンジニア, パーソナルメンター',
            noIndexNofollow: false,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  data() {
    return {
      email: '',
      errors: [],
      applicationErrors: [],
    }
  },
  computed: {},
  async mounted() {},
  methods: {
    onSubmit() {
      const body: any = {
        email: this.email,
      }
      validatePasswordForgotForm(body)
        .then(() => {
          postYahooPasswordForgot(this.$api, body)
            .then(() => {
              window.location.href = '/'
            })
            .catch((errors: any) => {
              this.applicationErrors = errors?.response?.data?.errors
            })
        })
        .catch((errors: any) => {
          this.errors = errors
        })
    },
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
@import url('~/assets/css/YaTe/YaTeCommon/YaTeCommon.css');

.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
